var SpriteSymbol = require("../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"info\">\r\n  <path d=\"M6.75 1.8125C6.75 1.0915 7.3415 0.5 8.0625 0.5H8.9375C9.6585 0.5 10.25 1.0915 10.25 1.8125V2.6875C10.25 3.4085 9.6585 4 8.9375 4H8.0625C7.71483 3.99862 7.38179 3.85989 7.13595 3.61405C6.89011 3.36821 6.75138 3.03517 6.75 2.6875V1.8125Z\" />\r\n  <path d=\"M12 14.5H5V12.75H6.75V7.5H5V5.75H10.25V12.75H12V14.5Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol